import useClusterConfig, { useUpdateClusterConfig } from "hooks/useClusterConfig";
const CUSTOM_HEADER_BADGE = "org.graylog.plugins.customization.HeaderBadge";
export const useUpdateHeaderBadge = () => useUpdateClusterConfig(CUSTOM_HEADER_BADGE);
const useHeaderBadge = () => useClusterConfig(CUSTOM_HEADER_BADGE);
export default useHeaderBadge;
